


































import { genVuexComputeds } from '@/main/pages/editFactory';
import dayjs from 'dayjs';
import _ from 'lodash';
import { Row, Table } from '@/main/utils/table';

import { DmsBaseComponent } from '#components/dms/common/base';

import { ZAKAZKA_DRUH } from '../constants';
import { store } from '../store/edit';

export default DmsBaseComponent.extend({
	name: 'ElsaButtons',
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			windowWidth: window.innerWidth,
		};
	},
	computed: {
		...genVuexComputeds(store),
		elsaImgs() {
			return require.context('@/assets/icons/elsaIcons/', false, /\.svg$/);
		},
		elsaRButtons(): { labelKey: string; click: Function; icon: string }[] {
			return this.elsaRExternalUrls
				.filter((item) => !_.isNil(item.Available && item.Url))
				.map((item) => ({
					labelKey: item.App,
					click: () => {
						window.open(item.Url.replace('<MESSID>', dayjs().format('DDMMYYYYhhmmssSSS')), '_blank');
					},
					icon: this.getImgUrl(item.App),
				}));
		},
		vozidloIcon(): string {
			return this.getImgUrl('Info_o_vozidle');
		},
		zakazkaExists(): boolean {
			return this.ZakazkaId! > 0;
		},
		isPrevodNdDruh(): boolean {
			return this.ZakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND;
		},
		carDescriptionSections(): string[] {
			const { rows, cellNames } = this.carDescription.equipmentData;
			return rows.reduce((acc: string[], currentValue: Row) => {
				if (!acc.some((i) => i === currentValue.cells[cellNames!.EQUIP_CLASS_TXT])) {
					acc.push(currentValue.cells[cellNames!.EQUIP_CLASS_TXT]);
				}
				return acc;
			}, []);
		},
	},
	mounted() {
		this.mainCollapse = [...this.mainCollapse, 'vehicleDescriptionMain', 'vehicleDescription0', 'vehicleDescription1'];
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		getImgUrl(name: string) {
			return this.elsaImgs(`./${name}.svg`);
		},
		getLocText(text: string) {
			return this.LocalizePopisostatni(text);
		},
		infoOVozidle() {
			this.carDescription.visible = true;
		},
		equipmentSectionTable(sectionName: string) {
			const { equipmentData } = this.carDescription;
			const vybavaKodText = equipmentData.cellNames!.EQUIP_CLASS_TXT;
			return new Table({
				...equipmentData,
				rows: equipmentData.rows.filter((row) => row.cells[vybavaKodText] === sectionName),
			});
		},
	},
});
